const fallbackApiBaseUrl = 'https://ca-ascensa-api.wittywave-921fced7.eastus2.azurecontainerapps.io';

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID || '';

export const adminConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || fallbackApiBaseUrl,
  entra: {
    tenantId: import.meta.env.VITE_ENTRA_TENANT_ID || '',
    clientId,
    apiScope: import.meta.env.VITE_ENTRA_API_SCOPE || (clientId ? `api://${clientId}/access_as_user` : ''),
  },
};

export const configIssues = [
  ['VITE_ENTRA_TENANT_ID', adminConfig.entra.tenantId],
  ['VITE_ENTRA_CLIENT_ID', adminConfig.entra.clientId],
].flatMap(([name, value]) => (value ? [] : [`${name} is required`]));

export const isEntraConfigured = configIssues.length === 0;
